import { render, staticRenderFns } from "./NotificacaoList.vue?vue&type=template&id=9564d88e"
import script from "./NotificacaoList.vue?vue&type=script&lang=js"
export * from "./NotificacaoList.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoList.vue?vue&type=style&index=0&id=9564d88e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports